import React, { useState, useEffect } from 'react';

// Keyframes are defined in a style tag for broader compatibility with CSS-in-JS.
const keyframes = `
    @keyframes logo-appear {
        from {
            opacity: 0;
            transform: scale(0.8);
        }
        to {
            opacity: 1;
            transform: scale(1);
        }
    }
    @keyframes text-appear {
        from {
            opacity: 0;
            transform: translateY(20px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }
`;

const SplashScreen = () => {
    const [logoUrl, setLogoUrl] = useState(null);

    useEffect(() => {
        const backendUrl = process.env.REACT_APP_BACKEND_URL || "http://localhost:4000";

        fetch(`${backendUrl}/api/signed-url/${encodeURIComponent('logo.jpeg')}`, {
            credentials: 'include',
        })
            .then((r) => r.json())
            .then((data) => setLogoUrl(data.signedUrl))
            .catch((err) => console.error("Failed to load logo from S3", err));
    }, []);

    return (
        <>
            <style>{keyframes}</style>
            <div style={styles.splashScreen}>
                <div style={styles.contentContainer}>
                    {logoUrl && (
                        <img
                            src={logoUrl}
                            alt="5RsPhysio Logo"
                            style={styles.splashLogo}
                            onError={(e) => {
                                e.target.style.display = 'none';
                                console.error("Failed to render logo");
                            }}
                        />
                    )}
                    <p style={styles.splashText}>
                        India's Healthy Ageing Platform
                    </p>
                </div>
            </div>
        </>
    );
};

// --- Styles ---
const styles = {
    splashScreen: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        backgroundColor: '#FFFFFF',
    },
    contentContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        padding: '2rem',
    },
    splashLogo: {
        width: '250px',
        height: 'auto',
        marginBottom: '2rem',
        animation: 'logo-appear 1.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) forwards',
    },
    splashText: {
        fontSize: '1.3rem',
        maxWidth: '450px',
        lineHeight: '1.7',
        color: '#0D47A1',
        fontWeight: '500',
        fontFamily: 'sans-serif',
        opacity: 0,
        animation: 'text-appear 1.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) 0.5s forwards',
    },
};

export default SplashScreen;